import Constants from '../constants.ts'
export async function checkFeeAgreementStatus(store) {
  try {
    const profileData = await store.dispatch("getAttProfileData");
    if (!profileData) return false;

    const followUp = profileData.follow_up;
    if (followUp) {
      const parsedFollowUp = JSON.parse(followUp);
      const isFeeAgreement2025Selected = parsedFollowUp.some(
        item => item.title === "Fee Agreement 2025" && item.selected === "true"
      );

      return isFeeAgreement2025Selected;
    }

    return false;
  } catch (e) {
    console.error("Failed to check fee agreement:", e);
    return false;
  }
}

export async function generateDynamicLink(attid) {
  const secret = Constants.SECRET_KEY;
  if (!attid) {
    console.error("attid is not available");
    return "";
  }

  const encoder = new TextEncoder();
  const keyBytes = encoder.encode(secret);
  const dataBytes = encoder.encode(`attid=${attid}`);

  try {
    const key = await crypto.subtle.importKey(
      'raw',
      keyBytes,
      { name: 'HMAC', hash: { name: 'SHA-256' } },
      false,
      ['sign']
    );

    const signature = await crypto.subtle.sign('HMAC', key, dataBytes);

    let sig = '';
    const view = new DataView(signature);
    for (let i = 0; i < signature.byteLength; i++) {
      sig += ('00' + view.getUint8(i).toString(16)).slice(-2);
    }

    let baseUrl;
    const origin = window.location.origin;
    if (origin === "http://localhost:8080") {
      baseUrl = "http://localhost:8080";
    } else if (origin === "https://devattportal.uslegalservices.net") {
      baseUrl = "http://devattportal.uslegalservices.net";
    } else {
      baseUrl = "https://attorney.uslegalservices.net";
    }

    return `${baseUrl}/2025feeschedule/attid=${attid}?sig=${sig}`;
  } catch (error) {
    console.error("Error generating HMAC:", error);
    return "";
  }
}
